import request from '@/utils/request'
// eslint-disable-next-line
import { Config } from './config'

const BASE_URL = Config.restUrl


// 查询景区团队数据 选择日期和类型
export function getScenicOfflineRevenues (type = 10, date) {
  return request({
    url: `${BASE_URL}business_tourism/scenic_offline_revenues/get_by_applet?type=${type}&date=${date}`,
    method: 'get'
  })
}

// 单日期, 或范围日期点击表格的 行
export function getSalaryMonthSummary (start, end, months = '') {
  return request({
    url: `${BASE_URL}infrastructure_oa/hr/get_salary_month_summary`,
    method: 'post',
    data: {
      start: start,
      end: end,
      months: months
    }
  })
}

export function getScenicPersons (companyId, currentDate, searchType) {
  return request({
    url: `${BASE_URL}business_tourism/revenueBriefing/get_scenic_persons/${companyId}?currentDate=${currentDate}&searchType=${searchType}`,
    method: 'get'
  })
}


export function loginNoPw (code) {
  return request({
    url: `${BASE_URL}core_organization/users/ding_user_get_by_code?code=${code}&dingType=0`,
    method: 'get'
  })
}

// dateType 1:单个日期 2:范围日期

// 单日期点击行
// export function getImg (companyId, typeCode, date) {
//   return request({
//     // url: `${BASE_URL}business_tourism/revenueBriefing/export_to_img?companyID=${companyId}&date=${date}&projectType=${typeCode}`,
//     url: `${BASE_URL}business_tourism/revenueBriefing/export_range_to_img?companyID=${companyId}&date=${date}&endDate=${date}&projectType=${typeCode}`,
//     method: 'post'
//   })
// }

// 单日期, 或范围日期点击表格的 行
export function getImgRange (companyId, typeCode, date, endDate, dateType, yearDiff = 1) {
  return request({
    url: `${BASE_URL}business_tourism/revenueBriefing/export_range_to_img?companyID=${companyId}&date=${date}&endDate=${endDate}&projectType=${typeCode}&dateType=${dateType}&yearDiff=${yearDiff}`,
    method: 'post'
  })
}

// 单日期, 或范围日期点击表格的 当月营收格子
export function getImgMonthBis (companyId, date) {
  return request({
    url: `${BASE_URL}business_tourism/revenueBriefing/get_month_info?companyID=${companyId}&month=${date}`,
    method: 'post'
  })
}

// 单日期 酒店餐饮横向对比
// export function getHorizontalComparisonOfHotelAndDiningImg (date) {
//   return request({
//     // url: `${BASE_URL}business_tourism/revenueBriefing/export_hotel_to_img?date=${date}`,
//     url: `${BASE_URL}business_tourism/revenueBriefing/export_hotel_range_to_img?date=${date}&endDate=${date}`,
//     method: 'post'
//   })
// }

// 范围日期 酒店餐饮横向对比
export function getHorizontalComparisonOfHotelAndDiningImgRange (date, endDate, dateType, yearDiff = 1) {
  return request({
    url: `${BASE_URL}business_tourism/revenueBriefing/export_hotel_range_to_img?date=${date}&endDate=${endDate}&dateType=${dateType}&yearDiff=${yearDiff}`,
    method: 'post'
  })
}

// 单日期 范围日期 两用 景区二消横向对比
export function getHorizontalComparisonOfScenicSpotsImgRange (date, endDate, dateType) {
  return request({
    url: `${BASE_URL}business_tourism/revenueBriefing/export_scenic_range_to_img?date=${date}&endDate=${endDate}&dateType=${dateType}`,
    method: 'post'
  })
}

// 单日期拉取表格数据
// export function getDailyRevenue (date, userId) {
//   return request({
//     // url: `${BASE_URL}business_tourism/revenueBriefing/get_applet_daily_revenue?date=${date}&uid=${userId}`,
//     url: `${BASE_URL}business_tourism/revenueBriefing/get_applet_daily_revenue_range?date=${date}&endDate=${date}&uid=${userId}`,
//     method: 'get'
//   })
// }

// 范围日期拉取表格数据
export function getDailyRevenueRange (date, endDate, userId, dateType, yearDiff) {
  return request({
    url: `${BASE_URL}business_tourism/revenueBriefing/get_applet_daily_revenue_range4?date=${date}&endDate=${endDate}&uid=${userId}&dateType=${dateType}&yearDiff=${yearDiff}`,
    method: 'get'
  })
}

export function getGroups () {
  return request({
    url: `${BASE_URL}core_organization/post_demands/get_groups`,
    method: 'get'
  })
}

export function getGroupDetail (companyId, typeId) {
  return request({
    url: `${BASE_URL}core_organization/post_demands/get_group_detail/${typeId}?CompanyID=${companyId}`,
    method: 'get'
  })
}

export function createResult (params) {
  return request({
    url: `${BASE_URL}infrastructure_oa/survey/survey_record`,
    method: 'post',
    data: params
  })
}

export function getList () {
  return request({
    url: `${BASE_URL}infrastructure_oa/survey/1/100?IsUse=true`,
    method: 'get'
  })
}

export function getQuestions (id) {
  return request({
    url: `${BASE_URL}infrastructure_oa/survey/survey_questions/1/100?SurveyID=${id}`,
    method: 'get'
  })
}
